module.exports = __webpack_public_path__ + "assets/img/fda63381acf1e64db16b94d4d59eb6a4.png";